import CustomInputText from "@/components/desktop/form/input/input-text/CustomInputText";
import CustomInputNumber from "@/components/desktop/form/input/input-number/CustomInputNumber";
import CustomInputSelect from "@/components/desktop/form/input/input-select/CustomInputSelect";

import styles from "./PhytosanitaryApplicationForm.module.scss";

const PhytosanitaryApplicationNewHeader = ({ formState, formErrors, updateHeaderField, lookups, filteredCropDetails, isIrrigation }) => {
	return (
		<>
			<div className={styles.programToggle}>
				<button
					type="button"
					className={`${styles.programToggleBtn} ${!formState.isNewProgram ? styles.programToggleBtnActive : ""}`}
					onClick={() => {
						updateHeaderField("isNewProgram", false);
						updateHeaderField("newProgramName", "");
						updateHeaderField("newProgramCropCustomerID", null);
						updateHeaderField("newProgramCropDetailID", null);
						updateHeaderField("newProgramOATypeCustomerID", null);
					}}
				>
					Programa Existente
				</button>
				<button
					type="button"
					className={`${styles.programToggleBtn} ${formState.isNewProgram ? styles.programToggleBtnActive : ""}`}
					onClick={() => {
						updateHeaderField("isNewProgram", true);
						updateHeaderField("phytosanitaryProgramID", null);
					}}
				>
					Crear Programa
				</button>
			</div>

			<div className={styles.generalGrid}>
				{formState.isNewProgram ? (
					<>
						<div style={{ gridColumn: "span 4" }}>
							<CustomInputText
								label="Nombre del Programa"
								name="newProgramName"
								value={formState.newProgramName}
								onChange={(value) => updateHeaderField("newProgramName", value)}
								placeholder="Ej: Programa Manzanas 2025"
								required
								error={formErrors.newProgramName}
							/>
						</div>

						<div style={{ gridColumn: "span 4" }}>
							<CustomInputSelect
								label="Campo"
								name="newProgramEstateParentID"
								options={lookups?.estate_parents || []}
								value={formState.newProgramEstateParentID}
								onChange={(value) => updateHeaderField("newProgramEstateParentID", value)}
								placeholder="Seleccionar campo..."
								required
								isClearable={false}
								error={formErrors.newProgramEstateParentID}
							/>
						</div>

						<div style={{ gridColumn: "span 4" }}>
							<CustomInputSelect
								label="Especie"
								name="newProgramCropCustomerID"
								options={(lookups?.crops || []).filter((crop) => crop.value !== 0)}
								value={formState.newProgramCropCustomerID}
								onChange={(value) => {
									updateHeaderField("newProgramCropCustomerID", value);
									updateHeaderField("newProgramCropDetailID", null);
								}}
								placeholder="Seleccionar..."
								required
								error={formErrors.newProgramCropCustomerID}
							/>
						</div>

						<div style={{ gridColumn: "span 6" }}>
							<CustomInputSelect
								label="Variedad"
								name="newProgramCropDetailID"
								options={filteredCropDetails}
								value={formState.newProgramCropDetailID}
								onChange={(value) => updateHeaderField("newProgramCropDetailID", value)}
								placeholder="Seleccionar..."
								disabled={!formState.newProgramCropCustomerID}
							/>
						</div>

						<div style={{ gridColumn: "span 6" }}>
							<CustomInputSelect
								label="Tipo Aplicación"
								name="newProgramOATypeCustomerID"
								options={lookups?.application_types || []}
								value={formState.newProgramOATypeCustomerID}
								onChange={(value) => updateHeaderField("newProgramOATypeCustomerID", value)}
								placeholder="Tipo..."
							/>
						</div>
					</>
				) : (
					<div style={{ gridColumn: "span 12" }}>
						<CustomInputSelect
							label="Programa Fitosanitario"
							name="phytosanitaryProgramID"
							options={lookups?.phytosanitary_programs || []}
							value={formState.phytosanitaryProgramID}
							onChange={(value) => updateHeaderField("phytosanitaryProgramID", value)}
							placeholder="Seleccionar programa..."
							required
							error={formErrors.phytosanitaryProgramID}
						/>
					</div>
				)}

				<div style={{ gridColumn: "span 3" }}>
					<CustomInputNumber
						label="Nº Aplicación"
						name="applicationNumber"
						value={formState.applicationNumber}
						onChange={(value) => updateHeaderField("applicationNumber", value)}
						required
						error={formErrors.applicationNumber}
					/>
				</div>

				<div style={{ gridColumn: "span 3" }}>
					<CustomInputText
						label="Época"
						name="periodText"
						value={formState.periodText}
						onChange={(value) => updateHeaderField("periodText", value)}
					/>
				</div>

				<div style={{ gridColumn: isIrrigation ? "span 6" : "span 3" }}>
					<CustomInputSelect
						label="Estado Fenológico"
						name="phenologicalStateID"
						options={lookups?.phenological_states || []}
						value={formState.phenologicalStateID}
						onChange={(value) => {
							const found = (lookups?.phenological_states || []).find((option) => option.value === value);
							updateHeaderField("phenologicalStateID", value);
							updateHeaderField("phenologicalStateText", found?.label || "");
						}}
						placeholder="Seleccionar..."
					/>
				</div>

				{!isIrrigation && (
					<div style={{ gridColumn: "span 3" }}>
						<CustomInputNumber
							label="Mojamiento"
							name="wetness"
							value={formState.wetness}
							onChange={(value) => updateHeaderField("wetness", value)}
							placeholder="L/Ha"
						/>
					</div>
				)}
			</div>
		</>
	);
};

export default PhytosanitaryApplicationNewHeader;
